<div class="no-gutters login-content-lg">
  @if (user$ | async; as user) {
    <div class="consent-body">
      <h1>{{ user.consentTitle }}</h1>
      @if (user.consentText) {
        <div class="consent-description">
          <div [innerHTML]="user.consentText"></div>
        </div>
      }
      <br />
      <button class="btn btn-primary btn-sm" (click)="approve()">
        {{ 'aimo.consent.approve' | cxTranslate }}
      </button>
      <button class="btn btn-secondary btn-sm ml-2" (click)="deny()">
        {{ 'aimo.consent.deny' | cxTranslate }}
      </button>
    </div>
  }
</div>
